<template>
  <div class="row">
    <div class="col-8"/>
    <div class="col">
      <Button label="Ajouter un dossier" @click="ajouterFolder"/>
    </div>
  </div>
  <div class="row">
    <div class="col-8"/>
    <div class="col">
      <FileUpload
        mode="basic"
        :accept="ALLOWED_FILETYPES"
        chooseLabel="Ajouter un fichier"
        class="p-button-sm p-button-rounded"
        :customUpload="CUSTOM_UPLOAD"
        :auto="AUTO_UPLOAD"
        @uploader="ajouterFichier"
        :multiple="false"
        ref="fileUpload"
      />
    </div>
  </div>
  <div class="row">
    <div class="col-1">
      <Button icon="pi pi-arrow-left" class="p-button-datatable p-button-sm"
          @click="precedant()" :disabled="currentIndex.id == 0"/>
    </div>
    <div class="col bold left">
      <p> {{ currentIndex.nom }} </p>
    </div>
    <div class="col-1">
      <div v-if="isFichierLoading">
        <vue-loaders name="ball-beat"></vue-loaders>
      </div>
    </div>
    <div class="col-8"/>
  </div>
  <div class="row border-white">
    <div class="col">
      <div v-for="current in index" v-bind:key="current" class="row">
        <div class="col-1">
          <div v-if="current.isFichier">
            <p class="pi pi-file"/>
          </div>
          <div v-else>
            <p class="pi pi-folder"/>
          </div>
        </div>
        <div v-if="current.isFichier" class="col hyperlink" @click="selectionner(current)">{{ current.nom }}</div>
        <div v-else class="col hyperlink bold" @click="selectionner(current)">{{ current.nom }}</div>
        <div class="col-1">
          <Button v-if="current.id != 1" icon="pi pi-trash" class="p-button-datatable p-button-sm"
              @click="confirmerSuppression(current)" />
        </div>
      </div>
    </div>
  </div>
  <ConfirmDialog></ConfirmDialog>
</template>

<script>
import axios from 'axios';
import {mapGetters} from "vuex";

export default {
  name: 'Index',
  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.currentIndex.id = 0;
    this.obtenirEnfants(this.currentIndex.id);
  },
  created() {
    this.ALLOWED_FILETYPES = "application/*, image/*, text/plain"
    this.AUTO_UPLOAD = true
    this.CUSTOM_UPLOAD = true
  },
  data() {
      return {
        index: [],
        currentIndex: {},
        indexASupprimer: null,
        isFichierLoading: false,
      };
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
    })
  },
  methods : {
    ajouterFolder() {
      var nomDossier = prompt("nom du dossier : ");
      if(nomDossier != null){
        this.isFichierLoading = true;
        var index = {}
        index.nom = nomDossier;
        index.isFichier = false;
        index.idParent = this.currentIndex.id;
        this.$store.dispatch("index/ajouterIndexAction", index).then(res => {
          this.index.push(res.data)
          this.isFichierLoading = false;
        });
      }
    },
    ajouterFichier(upload) {
      this.isFichierLoading = true;
      var index = {}
      var file = upload.files[0];

      index.nom = file.name;
      index.isFichier = true;
      index.idParent = this.currentIndex.id;
      index.type = file.name.split('.')[file.name.split('.').length-1];
      index.contenu = URL.createObjectURL(file);

      this.$store.dispatch('multimedia/obtenirBlobAction', {
        donnees: index.contenu
      }).then((response) => {
        index.contenu = response
        this.$store.dispatch("index/ajouterIndexAction", index).then(res => {
          this.index.push(res.data)
          this.isFichierLoading = false;
        });
      })

    },
    confirmerSuppression(currentIndex) {
      this.indexASupprimer = currentIndex
      this.$confirm.require({
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        message: "Voulez-vous supprimer?",
        accept: this.retirer,
        reject: () => { },
      })
    },
    retirer() {
      this.$store.dispatch("index/retirerIndexAction", this.indexASupprimer).then(() => {
        const position = this.index.indexOf(this.indexASupprimer);
        if(position > -1) {
          this.index.splice(position, 1)
        }
      });
    },
    selectionner(newCurrent){
      if(!newCurrent.isFichier){
        this.obtenirEnfants(newCurrent.id);
      }else {
        this.isFichierLoading = true;
        this.$store.dispatch("index/consulterFichierAction", newCurrent.id).then(res => {
          var arr = res.data.contenu
          const linkSource = `data:application/pdf;base64,${arr}`;
          const downloadLink = document.createElement("a");
          const fileName = newCurrent.nom;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          this.isFichierLoading = false;
        });
      }
    },
    byteToUint8Array(byteArray) {
        var uint8Array = new Uint8Array(byteArray.length);
        for(var i = 0; i < uint8Array.length; i++) {
            uint8Array[i] = byteArray[i];
        }

        return uint8Array;
    },
    precedant() {
      this.obtenirEnfants(this.currentIndex.idParent);
    },
    obtenirEnfants(current) {
      this.$store.dispatch("index/obtenirIndexAction", current).then(res => {
        this.currentIndex = res.data.indexParent;
        this.index = res.data.list;
      });
    }
  }

}
</script>
